import React, { Component } from "react";

import { addSubAdmin } from "../services/userService";
import { setJwt } from "../services/httpService";
import { toast } from "react-toastify";

class UserAddSub extends Component {
  state = {
    errors: {}
  };

  async componentDidMount() {
    const jwt = localStorage.getItem("token");
    setJwt(jwt);
    console.log("Props", this.props);
    const username = this.props.match.params.username;
    const companyName = this.props.match.params.companyName;
    const handleID = this.props.match.params.handleID;
    console.log("usercompany and username", companyName, username);
    const res = await addSubAdmin(username, companyName);
    if (res.status !== 200) toast.error("Only the company admin can give subadmin privileges.")
    console.log("addSubadmin response", res);
    // window.location = `/systems/users/${handleID}`;
    this.props.history.push(`/systems/users/${handleID}/${companyName}`);
    // this.props.history.push(`/systems/webSocketComp`);
  }
  render() {
    return null;
  }
}

export default UserAddSub;
